'use strict';
var util = angular.module('gymsystem.util');
util.directive('payoutlist', ['server', '$rootScope', '$filter', 'live', function (server, $rootScope, $filter, live) {
        return {
            restrict: 'E',
            templateUrl: 'components/widgets/payoutlist/payoutlist.html',
            scope: {
                settings: '=?',
                control: '=?'
            },
            link: function ($scope) {
                var formatStatus = function (p) {
                    var value = { pending: 'Pending', sent: 'Sent', automatic: 'Automatically paid out' }[p.status] || p.status;
                    return $filter('translate')(value);
                };
                $scope.config = {
                    getItems: function () { return list; },
                    columns: [
                        { field: 'user', title: 'Customer', getValue: function (p) { return $rootScope.getMember(p.user_id).name; } },
                        { field: 'date', title: 'Date' },
                        { field: 'amount', title: 'Amount', format: 'price' },
                        { field: 'status', title: 'Status', getValue: formatStatus }
                    ],
                    rowClick: function () { },
                    hideSearchCount: true
                };
                var list = [];
                var load = function () {
                    server.get('/api/payout/get').then(function (response) {
                        list = response;
                    });
                };
                load();
                live.subscribe({
                    type: 'userpayout',
                    callback: load
                });
            }
        };
    }]);
